import React from "react";
import { Typography } from "antd";
import Icon from "@ant-design/icons";
import { ReactComponent as ReportsSvg } from "../../../assets/icons/reports.svg";
import { ReactComponent as SettingsSvg } from "../../../assets/icons/settings.svg";
import { ReactComponent as UsersSvg } from "../../../assets/icons/users.svg";
import "./styles.css";

const { Paragraph } = Typography;

const iconStyle = {
  width: 24,
  height: 24,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "8px",
  fontWeight: "700",
  color: "white",
};

// A mapping of string names → actual SVGs
const iconsMap = {
  reports: ReportsSvg,
  settings: SettingsSvg,
  users: UsersSvg,
};

const EmptyState = ({ message, iconName = "reports" }) => {
  const SelectedIcon = iconsMap[iconName] || ReportsSvg;

  return (
    <div className="prst-empty-state">
      <Icon
        style={{ ...iconStyle }}
        component={SelectedIcon}
        className="report-icon"
      />
      <Paragraph>{message}</Paragraph>
    </div>
  );
};

export default EmptyState;
